import { render, staticRenderFns } from "./BlockArchivedCustomers.vue?vue&type=template&id=53cdd7c2&scoped=true&"
import script from "./BlockArchivedCustomers.vue?vue&type=script&lang=js&"
export * from "./BlockArchivedCustomers.vue?vue&type=script&lang=js&"
import style0 from "./BlockArchivedCustomers.vue?vue&type=style&index=0&id=53cdd7c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53cdd7c2",
  null
  
)

export default component.exports